import axios from "axios"
import baseURL from "../config/api"

export const post_GroupForPublic = async (data: any) => {
    return await axios({
        url: `${baseURL}group/createGroupForPublic`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const post_FamilyMemberForPublic = async (data: any) => {
    return await axios({
        url: `${baseURL}FamilyMember/createFamilyMemberForPublic`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getUsernameForPublic = async (username: string) => {
    return await getFetch(`users/DoesUserNameExistForPublic/${username}`)
}

export const getEmailCheckingForPublic = async (email: string) => {
    return await getFetch(`users/DoesEmailExistForPublic/${encodeURIComponent(email)}`);
}

export const getFamilyMemberUsernameForPublic = async (username: string) => {
    return await getFetch(`FamilyMember/DoesFamilyMemberUserNameExistForPublic/${username}`)
}

export const getFamilyMemberEmailCheckingForPublic = async (email: string) => {
    return await getFetch(`FamilyMember/DoesFamilyMemberEmailExistForPublic/${encodeURIComponent(email)}`);
}

const getFetch = async (url: string, params = {}) => {
    return await axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}